(function ($, window, document, undefined) {
Checkout = ( function() {

	function Constructor() {

		var interval;
		var dialog;
		var dialog_action;
		var dialog_function;
		var loader;
		var signin_form;
		var verify_form;
		var phone_number;
		var first_name;
		var last_name;
		var verify_token;
		var has_started = false;

		function sendFormStartTracking() {
			if ( ! has_started ) {
				has_started = true;
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push( {
					'event': 'form_start'
				} );
			}
		}

		function sendFormSubmit() {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push( {
				'event': 'form_submit'
			} );
		}

		function dialogAction( e ) {
			dialog_function();
			e.preventDefault();
		}

		function showDialog( opts ) {
			console.log( opts );
			var success = opts.success;
			var title   = opts.title;
			var desc    = opts.message;
			var el_title  = dialog.querySelector( 'h3' );
			var el_desc   = dialog.querySelector( '.desc' );
			dialog.style.display = "block";
			dialog_function = opts.action;
			if ( success === false ) {
				dialog.classList.add( 'error' );
			}
			if ( ! title ) {
				title = success ? 'Success!' : 'Whoops!';
			}
			el_title.innerText = title;
			if ( ! desc ) {
				el_desc.innerText = '';
			} else {
				el_desc.innerHTML = desc;
			}
		}

		function hideDialog() {
			$.modal.close();
		}

		function showVerify() {
			dialog.style.display = "none";
			verify_form.style.display = "block";
		}

		function onVerify( result ) {
			console.log( result );
			loader.classList.remove("loading");
			if ( result.success ) {
				signin_form.style.display = "none";
				verify_form.style.display = "none";
				verify_token.value = '';
				updateList();
				showDialog( {
					success: result.success,
					message: ( result.success == true ? "You are signed in.  You will recieve an updated text message when the doctor is ready to see you." : "An unexpected error occurred." ),
					action: hideDialog,
				} );
			} else {
				verify_form.style.display = "none";
				showDialog( {
					success: result.success,
					message: result.data ? result.data : "An unexpected error occurred.",
					action: showVerify,
				} );
			}
		}

		function onStart( result ) {
			console.log( result );
			loader.classList.remove("loading");
			if ( result.success ) {
				signin_form.style.display = "none";
				verify_form.style.display = "block";
			} else {
				signin_form.style.display = "none";
				showDialog( {
					success: result.success,
					message: result.data ? result.data : "An unexpected error occurred.",
					action: hideDialog,
				} );
			}
		}

		function startSignIn( e ) {
			e.preventDefault();
			sendFormSubmit();
			loader.classList.add("loading");
			$.ajax( {
				url: ajaxurl,
				method: "POST",
				data: {
					action: 'start_signin',
					phone: phone_number.value,
					fname: first_name.value,
					lname: last_name.value,
				},
				traditional: true,
				cache: false,
				success: onStart
			} );
		}

		function verify( e ) {
			e.preventDefault();
			sendFormSubmit();
			loader.classList.add("loading");
			$.ajax( {
				url: ajaxurl,
				method: "POST",
				data: {
					action: 'verify_signin',
					phone: phone_number.value,
					fname: first_name.value,
					lname: last_name.value,
					token: verify_token.value
				},
				traditional: true,
				cache: false,
				success: onVerify
			} );
		}

		function onUpdateList( result ) {
			$( '#queue' ).empty();
			var html;
			if ( result.data.length == 0 ) {
				html = '<div class="empty">';
					html += '<span class="name">Ready for our first patient!</span>';
					html += '</div>';
				$( '#queue' ).append( html );
			}
			for ( var i = 0; i < result.data.length; i++ ) {
				var obj = result.data[i];
				html = '<div class="queuer status-' + obj.status.value + '">';
					html += '<span class="name">' + obj.fname + ' ' + obj.lname + '</span>';
					html += '<span class="created">' + obj.created + '</span>';
					html += '<span class="complete">' + obj.completed + '</span>';
					html += '<span class="status">' + obj.status.label + '</span>';
					html += '</div>';
				$( '#queue' ).append( html );
			}
		}

		function updateList() {
			clearInterval( interval );
			interval = setTimeout( updateList, 30000 );
			$.ajax( {
				url: ajaxurl,
				method: "POST",
				data: {
					action: 'queue_list'
				},
				traditional: true,
				cache: false,
				success: onUpdateList
			} );
		}

		this.start = function () {
			updateList();
			$('a[data-modal]').on('click', function() {
				$($(this).data('modal')).modal({
					escapeClose: false,
					clickClose: false,
				});
				signin_form.style.display = "block";
				verify_form.style.display = "none";
				dialog.style.display = "none";
				return false;
			});
			signin_form  = document.querySelector( "#sign-in-form" );
			verify_form  = document.querySelector( "#verify-form" );
			if ( signin_form ) {
				loader        = document.querySelector( "#loader" );
				phone_number  = document.querySelector( "#phone-number" );
				first_name    = document.querySelector( "#first-name" );
				last_name     = document.querySelector( "#last-name" );
				verify_token  = document.querySelector( "#verify" );
				dialog        = document.querySelector( '#response-dialog' );
				dialog_action = dialog.querySelector( '.btn' );
				form_fields   = signin_form.querySelectorAll( 'input' );
				form_fields.forEach( ( el ) => { 
					el.addEventListener( 'focus', sendFormStartTracking );
				} );
				signin_form.addEventListener( "submit", startSignIn );
				verify_form.addEventListener( "submit", verify );
				dialog_action.addEventListener( 'click', dialogAction, false );
			}
		};
		
	}
	return new Constructor();
	
}() );
})(jQuery, window, document); 